// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3VCJ9","error":"Textarea_error__3iJve","readonly":"Textarea_readonly__Fayi9","disabled":"Textarea_disabled__2SQUz"};